export enum LoanEmploymentMonthlyIncomeType {
    BASE_INCOME = "base_income",
    BONUSES = "bonuses",
    COMMISSION = "commission",
    CONTRACT_BASIS = "contract_basis",
    MILITARY_BASE_PAY = "military_base_pay",
    MILITARY_CLOTHES_ALLOWANCE = "military_clothes_allowance",
    MILITARY_COMBAT_PAY = "military_combat_pay",
    MILITARY_FLIGHT_PAY = "military_flight_pay",
    MILITARY_HAZARD_PAY = "military_hazard_pay",
    MILITARY_OVERSEAS_PAY = "military_overseas_pay",
    MILITARY_PROP_PAY = "military_prop_pay",
    MILITARY_QUARTERS_ALLOWANCE = "military_quarters_allowance",
    MILITARY_RATIONS_ALLOWANCE = "military_rations_allowance",
    MILITARY_VARIABLE_HOUSING_ALLOWANCE = "military_variable_housing_allowance",
    OTHER_EMPLOYMENT = "other_employment",
    OVERTIME = "overtime",
  }
  
  export const LoanEmploymentMonthlyIncomeTypeLabels = {
    [LoanEmploymentMonthlyIncomeType.BASE_INCOME]: "Base Income",
    [LoanEmploymentMonthlyIncomeType.BONUSES]: "Bonuses",
    [LoanEmploymentMonthlyIncomeType.COMMISSION]: "Commission",
    [LoanEmploymentMonthlyIncomeType.CONTRACT_BASIS]: "Contract Basis",
    [LoanEmploymentMonthlyIncomeType.MILITARY_BASE_PAY]: "Military Base Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_CLOTHES_ALLOWANCE]:
      "Military Clothes Allowance",
    [LoanEmploymentMonthlyIncomeType.MILITARY_COMBAT_PAY]: "Military Combat Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_FLIGHT_PAY]: "Military Flight Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_HAZARD_PAY]: "Military Hazard Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_OVERSEAS_PAY]:
      "Military Overseas Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_PROP_PAY]: "Military Prop Pay",
    [LoanEmploymentMonthlyIncomeType.MILITARY_QUARTERS_ALLOWANCE]:
      "Military Quarters Allowance",
    [LoanEmploymentMonthlyIncomeType.MILITARY_RATIONS_ALLOWANCE]:
      "Military Rations Allowance",
    [LoanEmploymentMonthlyIncomeType.MILITARY_VARIABLE_HOUSING_ALLOWANCE]:
      "Military Variable Housing Allowance",
    [LoanEmploymentMonthlyIncomeType.OTHER_EMPLOYMENT]: "Other (Employment)",
    [LoanEmploymentMonthlyIncomeType.OVERTIME]: "Overtime",
  };
  
  export const LoanEmploymentMonthlyIncomeTypeOptions = Object.values(
    LoanEmploymentMonthlyIncomeType
  ).map((value) => ({
    value,
    label:
      LoanEmploymentMonthlyIncomeTypeLabels[
        value as LoanEmploymentMonthlyIncomeType
      ],
  }));
  